__turbopack_context__.v({
  "btnWrapper": "Otp-module-scss-module__STWsGq__btnWrapper",
  "main": "Otp-module-scss-module__STWsGq__main",
  "termsAndCondition": "Otp-module-scss-module__STWsGq__termsAndCondition",
});
